import { ReactIcons } from "@kalyzee/kalyzee-ui";

import styles from "./RecordIndicator.module.css";
import clsx from "clsx";

export interface RecordIndicatorProps {
  animated?: boolean;
}

export const RecordIndicator: React.FC<RecordIndicatorProps> = ({ animated = true }) => {
  return (
      <ReactIcons.Broadcast 
        className={clsx({
          [styles.recordIndicator]: true,
          [styles.animated]: animated,
        })}
      />
  );
};